$(document).ready(function () {
    // Variant selection functions
    function selectedVarint() {
        var slectedId = $(".select__variant").val();
        var url = new URL(window.location.href);
        url.searchParams.set("variant", slectedId);
        window.history.replaceState({}, "", url);
    }

    function selectedUpdate() {
        var updateValue = "";
        $(".single__product-from input[type='radio']:checked").each(function () {
            updateValue += (updateValue ? " / " : "") + $(this).val();
        });

        $(".select__variant option").each(function () {
            var optionValue = $(this).text().trim();
            if (optionValue == updateValue) {
                $(this).prop("selected", true);
                var variant_name = $(this).attr("variant-title");
                $('.product-hero__color-name span').text(variant_name);
                var available = $(this).attr("data-available");

                if (available == 'false') {
                    $(".product-hero__quality-btn a").text('Sold out');
                    $(".product-hero__quality-btn").addClass("disabled");
                } else {
                    $(".product-hero__quality-btn a").text("add to cart");
                    $(".product-hero__quality-btn").removeClass("disabled");
                }
                return true;
            }
        });
    }

    $(".single__product-from input[type='radio']").change(function () {
        selectedUpdate();
        selectedVarint();
    });

    selectedUpdate();

    // Intercept Add to Cart form submission to prevent redirect
            $('#add-to-cart-form, #add-cart-form-mobile').on('submit', function (e) {
                e.preventDefault();
                var formData = $(this).serialize();
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: formData,
                    dataType: "json",
                    success: function () {
                        sectionRender();
                        $(".cart").addClass('active');
                        $(".overlay").addClass('active');
                    },
                    error: function (error) {
                        console.log("Error adding to cart:", error);
                    }
                });
            });

    // Quantity Selector Logic
    // Increment quantity
    $('.increment-btn').on('click', function () {
        var $quantityInput = $(this).siblings('.quantity-input');
        var currentValue = parseInt($quantityInput.val());
        if (!isNaN(currentValue)) {
            $quantityInput.val(currentValue + 1);
        }
    });

    // Decrement quantity
    $('.decrement-btn').on('click', function () {
        var $quantityInput = $(this).siblings('.quantity-input');
        var currentValue = parseInt($quantityInput.val());
        if (!isNaN(currentValue) && currentValue > 1) {
            $quantityInput.val(currentValue - 1);
        }
    });
});

// Function to update cart drawer and header with latest cart content
function sectionRender() {
    fetch("?section_id=main-header")
        .then((res) => res.text())
        .then((data) => {
            var cart_html = $(data);
            var render_html = $(".header__right-cart", cart_html);
            $(".header__right-cart").replaceWith(render_html);
        });

    fetch("?section_id=cart-drawer")
        .then((res) => res.text())
        .then((data) => {
            var cart_html = $(data);
            var render_html = $(".cart__inner", cart_html);
            $(".cart__inner").replaceWith(render_html);

            // Reinitialize slick for any carousel in the cart drawer
            $('.cart__product-add-items').slick({
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                adaptiveHeight: true
            });
        });
}

function addUpsell_porduct($this, event) {
    event.preventDefault();
    var formData = $($this).closest(".upsell_product").serialize();

    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: formData,
        success: function () {
            sectionRender();
        },
        error: function (err) {
            console.log("Error adding products:", err);
        }
    });
}

function increment(el) {
    var input = el.previousElementSibling;
    var value = parseInt(input.value);
    value = isNaN(value) ? 0 : value;
    value++;
    input.value = value;
    changeQuantity(input);
}

function decrement(el) {
    var input = el.nextElementSibling;
    var value = parseInt(input.value);
    if (value > 0) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
        changeQuantity(input);
    }
}

function changeQuantity(input) {
    var quantity = $(input).val();
    var data_line = $(input).attr("data-line");
    var data = {
        "line": data_line,
        "quantity": quantity
    };

    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: data,
        success: function (data) {
            sectionRender();
        },
        error: function (err) {
            console.log("Error updating quantity:", err);
        }
    });
}

function removeItem(event, el) {
    event.preventDefault();
    var data_line = $(el).attr("data-line");

    var deleteData = {
        "line": data_line,
        "quantity": 0
    };

    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: deleteData,
        success: function (data) {
            sectionRender();
        },
        error: function (err) {
            console.log("Error removing item:", err);
        }
    });
}

// Select all add-ons when "ADD ALL" button is clicked
$(".product-hero__add-ons-top-right").on("click", function () {
    $(".product-hero__add-ons-items input").prop("checked", true);
});

// Add main product and selected add-ons to the cart
$(".product-hero__quality-btn").on("click", function (e) {
    e.preventDefault();
    var mainProductId = $('.select__variant').val();
    var quantity = parseInt($('.quantity-input').val());
    var additionalProductIds = [];

    $(".product-hero__add-ons-items input[type='checkbox']:checked").each(function () {
        additionalProductIds.push($(this).val());
    });

    var lineItems = [{
        id: mainProductId,
        quantity: quantity
    }];

    additionalProductIds.forEach(function (productId) {
        lineItems.push({
            id: productId,
            quantity: 1
        });
    });

    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
            items: lineItems
        },
        success: function () {
            sectionRender();
            $(".cart").addClass('active');
            $(".overlay").addClass('active');
        },
        error: function (err) {
            console.log("Error adding products:", err);
        }
    });
});